module.exports = __webpack_public_path__ + "img/news-3.5baaa18.png";